import React from 'react';
import { useSelector } from 'react-redux';
import { useLazyGetSeoResultQuery } from 'store/api/activitiesApi';
import { SeoModel, SeoViewModel } from 'core/type/Seo';
import { isDetailPage } from 'core/constant/analytics/AnalyticsPageType';
import { mapDescriptionFromContent, mapTitleFromContent } from 'gql/service/graph/activityService';
// eslint-disable-next-line import/no-restricted-paths
import { selectActivityFromDetailState } from 'component/page/detail/store/detail.selectors';

const mapSeoResponse = (seoData?: SeoModel): SeoViewModel => {
    return {
        title: seoData?.metaText?.title ?? '',
        robots: seoData?.robots ?? '',
        description: seoData?.metaText?.description ?? '',
        keywords: seoData?.metaText?.description ?? '',
    };
};

const useSeoProps = () => {
    const [triggerGetSeoResultQuery, seoResponse] = useLazyGetSeoResultQuery();

    React.useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        triggerGetSeoResultQuery({});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return mapSeoResponse(seoResponse.data);
};

const useDetailPageSeoProps = () => {
    const activity = useSelector(selectActivityFromDetailState);
    const title = mapTitleFromContent(activity.content);
    const description = mapDescriptionFromContent(activity.content);
    return { title, description };
};

// useSeoData is called in client side rendering. To support SEO, it should be called in static page generating or server side rendering.
export const useSeoData = (pageTypeId: number): SeoViewModel => {
    const seoDataDefault = useSeoProps();

    const isDetailsPage = isDetailPage(pageTypeId);
    const seoDataOverride = useDetailPageSeoProps();

    let seoData: SeoViewModel = seoDataDefault;

    if (isDetailsPage) {
        seoData = {
            ...seoData,
            ...seoDataOverride,
        };
    }
    return seoData;
};
